import { TrackTypeEnum } from '@/entities/tracks'
import { type UpdateTrackModel } from '@/shared/api'

import type { JingleFormModel } from '..'

export function getJingleSubmitRequestByFormValues(
  values: JingleFormModel,
): UpdateTrackModel {
  return {
    name: values.name,
    fileIds:
      values.trackFile && values.trackFile.id ? [values.trackFile.id] : [],
    description: null,
    type: TrackTypeEnum.Jingle,
    authorId: null,
    coauthorIds: null,
    genreIds: null,
    albumId: null,
    pictureFileId: null,
    useAlbumPicture: false,
    releaseDate: null,
  }
}
